import yellowpapersJson from './yellowpapers.json' with { type: 'json' };
export const yellowpapers = yellowpapersJson;
